<template>
    <footer class="site-footer">
        <div class="footer-container">
            <!-- 网站信息区域 -->
            <div class="footer-info">
                <h2 class="footer-logo">本溪高新区科技成果转化综合服务平台</h2>
                <p class="footer-description">
                    专注于前沿科技资讯与创新解决方案，助力行业数字化转型
                </p>
                <!-- 快速链接 -->
                <!-- <div class="footer-links">
                    <h3 class="link-title">快速链接</h3>
                    <ul class="list-row">
                        <li><a href="/about" class="footer-link">关于我们</a></li>
                        <li><a href="/services" class="footer-link">服务项目</a></li>
                        <li><a href="/news" class="footer-link">新闻动态</a></li>
                        <li><a href="/careers" class="footer-link">加入我们</a></li>
                        <li><a href="/contact" class="footer-link">联系我们</a></li>
                    </ul>
                </div> -->
            </div>



            <!-- 联系方式 -->
            <div class="footer-contact">
                <h3 class="link-title">联系我们</h3>
                <ul class="contact-list">
                    <li class="contact-item">
                        <i class="fas fa-map-marker-alt contact-icon"></i>
                        <span>本溪市高新区管理委员会 辽宁省本溪市溪湖区高新区石桥子香槐路112号</span>
                    </li>
                    <!--TODO 电话邮箱要写吗-->
                    <li class="contact-item">
                        <i class="fas fa-phone contact-icon"></i>
                        <span>(024)45627612</span>
                    </li>
                    <li class="contact-item">
                        <i class="fas fa-envelope contact-icon"></i>
                        <span>bxgxqkjcxj@163.com</span>
                    </li>
                    <li class="contact-item">
                        <i class="fas fa-clock contact-icon"></i>
                        <span>周一至周五08:30-17:00</span>
                    </li>
                </ul>
            </div>

            <!-- 友情链接 -->
            <div class="footer-friendlinks">
                <h3 class="link-title">友情链接</h3>
                <div class="friendlink-list">
                    <a href="https://sytpre.com/#/" class="friendlink">辽宁省科技成果转化平台</a>
                    <a href="https://www.benxi.gov.cn/" class="friendlink">本溪市政府官网</a>
                    <a href="http://www.cnmc.gov.cn/" class="friendlink">本溪高新区官网</a>
                </div>
            </div>
        </div>

        <!-- 版权信息 -->
        <div class="footer-bottom">
            <div class="bottom-container">
                <p class="copyright">
                    &copy; {{ new Date().getFullYear() }} TechVision. 保留所有权利.
                    <a href="/privacy" class="copyright-link">隐私政策</a> |
                    <a href="/terms" class="copyright-link">使用条款</a>
                </p>
            </div>
        </div>
    </footer>
</template>

<script setup>
// 可以在这里添加需要的交互逻辑
</script>

<style scoped>
.site-footer {
    background-color: #1a1a2e;
    color: #ffffff;
    padding: 4rem 0 2rem;
    margin-top: 30px;
    font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;
}

.footer-container {
    display: grid;
    grid-template-columns: 2fr 1fr 1fr ;
    gap: 2rem;
    max-width: 1200px;
    margin: 0 auto;
    padding: 0 2rem;
}

.footer-info {
    display: flex;
    flex-direction: column;
    gap: 1rem;
}

.list-row {
    margin: 0;
    padding: 0;
    list-style: none;
    display: flex;
    gap: 20px;
}

.footer-logo {
    font-size: 1.8rem;
    font-weight: 700;
    margin: 0;
    color: #4cc9f0;
}

.footer-description {
    color: #b8b8b8;
    line-height: 1.6;
    margin: 0;
}

.social-links {
    display: flex;
    gap: 1rem;
    margin-top: 1rem;
}

.social-icon {
    width: 40px;
    height: 40px;
    border-radius: 50%;
    background-color: #2a2a42;
    color: #ffffff;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 1.2rem;
    transition: all 0.3s ease;
}

.social-icon:hover {
    background-color: #4cc9f0;
    transform: translateY(-3px);
}

.link-title {
    font-size: 1.2rem;
    font-weight: 600;
    margin-bottom: 1.5rem;
    position: relative;
    padding-bottom: 0.5rem;
}

.link-title::after {
    content: '';
    position: absolute;
    left: 0;
    bottom: 0;
    width: 40px;
    height: 3px;
    background-color: #4cc9f0;
}

.footer-links ul {
    list-style: none;
    padding: 0;
    margin: 0;
}

.footer-links li {
    margin-bottom: 0.8rem;
}

.footer-link {
    color: #b8b8b8;
    text-decoration: none;
    transition: color 0.3s ease;
}

.footer-link:hover {
    color: #4cc9f0;
    padding-left: 5px;
}

.contact-list {
    list-style: none;
    padding: 0;
    margin: 0;
}

.contact-item {
    display: flex;
    align-items: flex-start;
    gap: 0.8rem;
    margin-bottom: 1rem;
    color: #b8b8b8;
}

.contact-icon {
    color: #4cc9f0;
    margin-top: 3px;
    flex-shrink: 0;
}

.friendlink-list {
    display: flex;
    flex-wrap: wrap;
    gap: 1rem;
}

.friendlink {
    color: #b8b8b8;
    text-decoration: none;
    transition: all 0.3s ease;
    padding: 0.3rem 0.8rem;
    border-radius: 4px;
    background-color: #2a2a42;
}

.friendlink:hover {
    background-color: #4cc9f0;
    color: #ffffff;
}

.footer-bottom {
    background-color: #121224;
    margin-top: 3rem;
    padding: 1.5rem 0;
}

.bottom-container {
    max-width: 1200px;
    margin: 0 auto;
    padding: 0 2rem;
    text-align: center;
}

.copyright {
    color: #888888;
    margin: 0;
    font-size: 0.9rem;
}

.copyright-link {
    color: #888888;
    text-decoration: none;
    margin: 0 0.5rem;
}

.copyright-link:hover {
    color: #4cc9f0;
}

/* 响应式设计 */
@media (max-width: 992px) {
    .footer-container {
        grid-template-columns: repeat(2, 1fr);
    }
}

@media (max-width: 576px) {
    .footer-container {
        grid-template-columns: 1fr;
        gap: 2.5rem;
    }

    .footer-logo {
        font-size: 1.5rem;
    }

    .link-title {
        font-size: 1.1rem;
    }
}
</style>
